<template>
  <div>
    <div class="filter-btn">
      <div @click="openFilter(true)" class="btn">
        <el-image class="img" :src="shaixuan"></el-image>
        <span>筛选</span>
      </div>
    </div>
    <!-- 筛选 -->
    <el-drawer :class="[isApp ? '' : 'drawer']" direction="ltr" size="71%" :visible.sync="swtich" :before-close="handleClose" :with-header="false">
      <div class="filter">
        <div class="close-swtich" @click="handleClose">
          <span class="title">收缩</span>
          <el-image class="left-image" slot="prefix" :src="nvaLeft" fit="contain"></el-image>
        </div>
        <el-menu class="el-menu-vertical-demo" background-color="#fff" text-color="#000">
          <template>
            <el-submenu index="1">
              <template slot="title">
                <span class="title">楼栋</span>
              </template>
              <el-menu-item index="1-1">
                <el-checkbox-group @change="localUpdateFilter({ arr: $event, type: 0 })" v-model="activeBuildings">
                  <el-checkbox-button v-for="building in buildingAreas" :label="building.Name" :key="building.Name">{{ building.Name }}</el-checkbox-button>
                </el-checkbox-group>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">
                <span class="title">楼层</span>
              </template>
              <el-menu-item index="2-1">
                <el-checkbox-group @change="localUpdateFilter({ arr: $event, type: 1 })" v-model="activeFloors">
                  <template v-for="building in buildingAreas">
                    <template v-for="floor in building.Floors">
                      <el-checkbox-button v-if="activeBuildings.length == 0 || activeBuildings.indexOf(building.Name) != -1" :key="floor.Name" :label="building.Name + '||' + floor.Name">{{
                        floor.Name
                      }}</el-checkbox-button>
                    </template>
                  </template>
                </el-checkbox-group>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="3">
              <template slot="title">
                <span class="title">房间</span>
              </template>
              <el-menu-item index="3-1">
                <el-checkbox-group @change="localUpdateFilter({ arr: $event, type: 2 })" v-model="activeRomms">
                  <template v-for="building in buildingAreas">
                    <template v-if="activeBuildings.length == 0 || activeBuildings.indexOf(building.Name) != -1">
                      <template v-for="floor in building.Floors">
                        <template v-if="activeFloors.length == 0 || activeFloors.indexOf(building.Name + '||' + floor.Name) != -1">
                          <el-checkbox-button v-for="room in floor.Rooms" :key="room" :label="building.Name + '||' + floor.Name + '||' + room">
                            {{ room }}
                          </el-checkbox-button>
                        </template>
                      </template>
                    </template>
                  </template>
                </el-checkbox-group>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import shaixuan from '@/assets/imgs/icon-shaixuan-32@2x.png'
import nvaLeft from '@/assets/imgs/left@2x (2).png'
export default {
  data() {
    return {
      isApp: true,
      shaixuan,
      nvaLeft,
      swtich: false,
      buildingAreas: [],
      //选中楼区 楼层 房间
      activeBuildings: [],
      activeFloors: [],
      activeRomms: [],
      areaArr: [],
      floorArr: [],
      roomArr: [],
      userList: [],
      filterParams: {}
    }
  },
  created() {
    this.isApp = localStorage.getItem('isApp') === '0'
    this.buildingAreas = this.$store.state.filter.buildingAreas
  },
  methods: {
    openFilter() {
      this.swtich = !this.swtich
      this.buildingAreas = this.$store.state.filter.buildingAreas
    },

    // 点击筛选条件
    localUpdateFilter({ type, arr }) {
      // console.log('{type,arr}: ', { type, arr })
      this.filterParams = { type, arr }
      switch (type) {
        case 0:
          this.areaArr = arr
          this.floorArr = []
          this.roomArr = []
          this.activeFloors = []
          this.activeRomms = []

          break
        case 1:
          this.floorArr = arr
          this.roomArr = []
          this.activeRomms = []

          break
        case 2:
          this.roomArr = arr
          break
        default:
          break
      }
      this.filterRoom()
    },

    // 筛选的数据
    filterRoom() {
      let rooms = []
      // 房间号
      if (this.roomArr.length) {
        this.roomArr.forEach((item) => {
          const area = item.split('||')[0]
          const floor = item.split('||')[1]
          const room = item.split('||')[2]
          const data = this.buildingAreas
            .find((el) => el.Name === area)
            .Floors.find((el) => el.Name === floor)
            .Rooms.find((el) => el === room)
          rooms.push(data)
        })
      } else if (this.floorArr.length) {
        // 楼层
        this.floorArr.forEach((item) => {
          const area = item.split('||')[0]
          const floor = item.split('||')[1]
          const data = this.buildingAreas.find((el) => el.Name === area).Floors.find((el) => el.Name === floor).Rooms
          rooms.push(...data)
        })
      } else {
        // 楼栋
        const area = this.buildingAreas.filter((item) => this.areaArr.find((el) => el === item.Name))
        area.forEach((item) => {
          item.Floors.forEach((val) => {
            rooms.push(...val.Rooms)
          })
        })
      }
      this.$emit('change', rooms)
    },

    // 关闭筛选
    handleClose() {
      this.swtich = false
    }
  }
}
</script>

<style scoped>
.filter-btn {
  width: 61px;
  height: 24px;
  padding: 0px !important;
  border: 1px solid #029fd1;
  color: #029fd1;
  line-height: 24px;
  border-radius: 12px !important;
  background-color: #fff;
  box-sizing: border-box;
}
.filter-btn .btn {
  display: flex;
  width: 61px;
  height: 24px;
  border-radius: 12px !important;
  line-height: 24px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #029fd1;
  margin-left: -2px;
  margin-top: -1px;
}

.filter-btn .img {
  width: 16px;
  height: 16px;
}

.drawer {
  top: 44px;
  height: calc(100vh - 44px);
}

.filter {
  width: 266px;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
}
.filter >>> .el-menu-item {
  padding: 0px !important;
}
.filter >>> .el-checkbox-group {
  display: flex;
  flex-flow: wrap;
}
.filter >>> .el-checkbox-button {
  width: 100px;
}
.filter >>> .el-checkbox-button {
  margin: 10px 6px 10px 0px;
}

.filter >>> .el-checkbox-button__inner {
  width: 100%;
  border-radius: 2px !important;
  padding: 6px 6px;
  border: 1px solid #c7c9cc;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #434649;
}
.filter >>> .el-submenu__title {
  padding: 0px !important;
  background-color: rgba(0, 0, 0, 0) !important;
}
.filter >>> .el-menu-item {
  background-color: rgba(0, 0, 0, 0) !important;
}

.filter >>> .el-submenu .el-menu-item,
.filter >>> .el-menu-item,
.filter >>> .el-submenu__title {
  height: auto;
}

.filter >>> .is-checked .el-checkbox-button__inner {
  background: #029fd1 !important;
  color: #fff !important;
}
/* .filter >>> .is-focus .el-checkbox-button__inner:hover{

} */
.el-menu {
  border-right: none;
}

.close-swtich {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 16px;
  margin: 0px 10px 10px 0px;
}
.left-image {
  width: 16px;
  height: 16px;
  margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/common/common-filter.vue